import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { style } from './CompletableTextGroup';
import { CheckableTextData } from './CheckableTextGroup';

interface CheckableTextTextEntryProps {
    number: number;
    id?: string;
    data: CheckableTextData;
    style?: style;
}

export const CheckableText: React.FC<CheckableTextTextEntryProps> = ({ data, style }) => {

    // const [text, setText] = React.useState(simpleText.text);
    const [checked, setChecked] = React.useState<boolean>(data.checked);
    const checkedName = data.checked && style === 'line-through' ? ' line-through' : '';

    return (
        <div className="completable-text-entry">
            {
                <Checkbox
                    checked={checked}
                    className='gl-completableText-checkbox'
                    onChange={
                        () => {
                            data.onItemChecked();
                            setChecked(data.checked);
                        }
                    }
                />
            }
            <p className={'gl-completableText-text gl-content-lowered-typography' + checkedName}>{data.text}</p>


        </div>
    );
};